
export enum PlantsEnum {
    UNIT_ONE = 'UNIT ONE',
    UNIT_TWO = 'UNIT TWO',
    KAKINADA = 'KAKINADA'
}